import { useOperatorProfileContext } from "provider/OperatorProfileProvider";
import React from "react";
import { Col, Row } from "react-bootstrap";

const ProfileOperatorsBusiness = () =>{
  const {operatorAccData } = useOperatorProfileContext();

  return (
    <>
      <div className="card account-settingside safartabs ">
        <div className="card-body p-4">
          <Row className="justify-content-end">
            <Col xs={10}>
              <Row>
                <Col xs={6} className="typeaccount">
                  <div>
                    <div className="mb-3">
                      <b>Business Name :</b> {operatorAccData?.business_name}
                    </div>
                    <div className="mb-3">
                      <b>Alternate Phone Number :</b> {operatorAccData?.operator_phone_no}
                    </div>
                      <div className="mb-3">
                      <b>Email Address :</b> {operatorAccData?.email}
                    </div>
                    <div className="mb-3">
                      <b>Alternate Email Address :</b> {operatorAccData?.operator_email}
                    </div>
                    <div className="mb-3">
                      <b>Registered Name :</b> {operatorAccData?.register_comapany_name}
                    </div>
                    <div className="mb-3">
                      <b>Rating :</b> {operatorAccData?.google_rating}
                    </div>
                    <div className="mb-3">
                      <b>Budget Segment :</b> {operatorAccData?.business_name}
                    </div>
                  </div>
                </Col>
                <Col xs={6} className="typeaccount">
                  <div>
                    <div className="mb-3">
                      <b>Business Name :</b> Developer
                    </div>
                    <div className="mb-3">
                      <b>Alternate Email Address :</b> sandeep@triline.co.in
                    </div>
                    <div className="mb-3">
                      <b>Category :</b> Safari Tour Operator
                    </div>
                    <div className="mb-3">
                      <b>Approved Status :</b> Yes
                    </div>
                    <div className="mb-3">
                      <b>Cancellation :</b> No
                    </div>
                  </div>
                </Col>
              </Row>
        
            </Col>
          </Row>
          
        </div>
      </div>
    </>
  );
}

export default ProfileOperatorsBusiness;
